<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">General Partner
                <span class="card-subtitle" v-if="user.profile">{{user.profile.first_name+' '+user.profile.last_name}} ({{user.email}})</span>
                <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/users/general-partners')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">General Partners</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0 pta-gp-weightings" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-8">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <user-sidebar menu="weightings" :id="id"></user-sidebar>
                                <div class="col-9 col-sm-9">
                                    <h4 class="card-title">Weightings</h4>
                                    <form @submit.prevent="submit" @keydown="userForm.errors.clear($event.target.name)">
                                        <div class="row">
                                            <div class="col-12 col-sm-12">
                                                <div class="row">
                                                    <div class="col-12 col-sm-4">
                                                        <div class="form-group">
                                                            <label for="">HQ Country</label>
                                                            <select v-model="userForm.weight_hqcountry">
                                                                <option v-for="n in 10" :value="n">{{ n }}</option>
                                                            </select>
                                                            <show-error :form-name="userForm" prop-name="weight_hqcountry"></show-error>
                                                        </div>
                                                    </div>
                                                  <div class="col-12 col-sm-4">
                                                    <div class="form-group">
                                                      <label for="">HQ Continent</label>
                                                      <select v-model="userForm.weight_hqcontinent">
                                                        <option v-for="n in 10" :value="n">{{ n }}</option>
                                                      </select>
                                                      <show-error :form-name="userForm" prop-name="weight_hqcontinent"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-4">
                                                    <div class="form-group">
                                                      <label for="">Preferred Geography</label>
                                                      <select v-model="userForm.weight_geo">
                                                        <option v-for="n in 10" :value="n">{{ n }}</option>
                                                      </select>
                                                      <show-error :form-name="userForm" prop-name="weight_geo"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-4">
                                                    <div class="form-group">
                                                      <label for="">Continent</label>
                                                      <select v-model="userForm.weight_cont">
                                                        <option v-for="n in 10" :value="n">{{ n }}</option>
                                                      </select>
                                                      <show-error :form-name="userForm" prop-name="weight_cont"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-4">
                                                    <div class="form-group">
                                                      <label for="">Investment Structure</label>
                                                      <select v-model="userForm.weight_struc">
                                                        <option v-for="n in 10" :value="n">{{ n }}</option>
                                                      </select>
                                                      <show-error :form-name="userForm" prop-name="weight_struc"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-4">
                                                    <div class="form-group">
                                                      <label for="">Preferred Fund Type</label>
                                                      <select v-model="userForm.weight_fundtype">
                                                        <option v-for="n in 10" :value="n">{{ n }}</option>
                                                      </select>
                                                      <show-error :form-name="userForm" prop-name="weight_fundtype"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-4">
                                                    <div class="form-group">
                                                      <label for="">Fund Type Category</label>
                                                      <select v-model="userForm.weight_fundtypecat">
                                                        <option v-for="n in 10" :value="n">{{ n }}</option>
                                                      </select>
                                                      <show-error :form-name="userForm" prop-name="weight_fundtypecat"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-4">
                                                    <div class="form-group">
                                                      <label for="">LP Type</label>
                                                      <select v-model="userForm.weight_lptype">
                                                        <option v-for="n in 10" :value="n">{{ n }}</option>
                                                      </select>
                                                      <show-error :form-name="userForm" prop-name="weight_lptype"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-4">
                                                    <div class="form-group">
                                                      <label for="">ESG Status</label>
                                                      <select v-model="userForm.weight_esg">
                                                        <option v-for="n in 10" :value="n">{{ n }}</option>
                                                      </select>
                                                      <show-error :form-name="userForm" prop-name="weight_esg"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-4">
                                                    <div class="form-group">
                                                      <label for="">First time fund</label>
                                                      <select v-model="userForm.weight_ftf">
                                                        <option v-for="n in 10" :value="n">{{ n }}</option>
                                                      </select>
                                                      <show-error :form-name="userForm" prop-name="weight_ftf"></show-error>
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                        <span @click.prevent="submit2" class="btn btn-sm btn-info pull-right" style="margin-left:10px;">Investor preview</span>
                                        <button type="submit" class="btn btn-sm btn-info pull-right">{{trans('general.save')}} & Reset Investors</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <user-summary :user="user"></user-summary>
            </div>
        </div>

      <div id="modalPreview" class="modal fade">
        <div class="modal-dialog" style="max-width:920px;">
          <div class="modal-content">
            <div class="modal-header" style="display:block;">
              <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
              <h4 id="modalTitle" class="modal-title">Investors preview</h4>
            </div>
            <div id="modalBody" class="modal-body" style="font-size:16px;line-height:22px;">
                <div v-if="is_loading">Please wait, the investors are loading ...</div>
              <div class="pta-investor-selection" style="font-size:24px;">
              <table v-if="!is_loading" class="table table-hover" style="max-width:100%;">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Cosine similarity</th>
                  <th>Preferred Geographic Area</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="investor in investors">
                  <td valign="top" v-html="investor.ID"></td>
                  <td valign="top" v-html="investor.Name"></td>
                  <td valign="top" v-html="investor.cosine_similarity"></td>
                  <td valign="top">
                    <span v-for="geo in investor.data.geos">{{geo}}</span>
                  </td>
                </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
</template>


<script>
    import userSidebar from './general-partner-sidebar'
    import userSummary from './summary'
    import switches from 'vue-switches'

    /*
• Weights assigned to different parameters (optional parameters, default value: 1)
• weights.hqcountry: HQ Country [value between 1 and 10]
• weights.hqcontinent: HQ Continent [value between 1 and 10]
• weights.geo: Preferred Geography [value between 1 and 10]
• weights.cont: Continent [value between 1 and 10]
• weights.struc: Investment Structure [value between 1 and 10]
• weights.fundtype: Preferred Fund Type [value between 1 and 10]
• weights.fundtypecat: Fund Type Category [value between 1 and 10]
• weights.lptype: LP Type [value between 1 and 10]
• weights.esg: ESG Status [value between 1 and 10]
• weights.ftf: First time fund [value between 1 and 10]
     */

    export default {
        components : { switches,userSidebar,userSummary },
        data() {
            return {
                id:this.$route.params.id,
                userForm: new Form({
                  weight_hqcountry: 2,
                  weight_hqcontinent: 2,
                  weight_geo: 10,
                  weight_cont: 10,
                  weight_struc: 1,
                  weight_fundtype: 10,
                  weight_fundtypecat: 4,
                  weight_lptype: 2,
                  weight_esg: 1,
                  weight_ftf: 1,
                },false),
                is_loading: true,
                user: '',
                investors: ''
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/account/dashboard');
            }
            this.fetchUserData();
        },
        methods: {
            showInvestorPreview(){
              this.is_loading = true;
              $('#modalPreview').modal();

              this.userForm.post('/api/investors-preview/'+this.id)
                  .then(response => {
                    this.investors = response;
                    this.is_loading = false;
                  })
                  .catch(error => {
                    helper.showDataErrorMsg(error);
                    this.$router.push('/users/general-partners');
                  });

              /* axios.get('/api/investors-preview/'+this.id)
                  .then(response => response.data)
                  .then(response => {
                    this.investors = response;
                    this.is_loading = false;
                  })
                  .catch(error => {
                    helper.showDataErrorMsg(error);
                    this.$router.push('/users/general-partners');
                  }) */
            },
            fetchUserData(){
                axios.get('/api/user/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.user = response.user;
                        this.userForm.weight_hqcountry = response.user.profile.weight_hqcountry;
                        this.userForm.weight_hqcontinent = response.user.profile.weight_hqcontinent;
                        this.userForm.weight_geo = response.user.profile.weight_geo;
                        this.userForm.weight_cont = response.user.profile.weight_cont;
                        this.userForm.weight_struc = response.user.profile.weight_struc;
                        this.userForm.weight_fundtype = response.user.profile.weight_fundtype;
                        this.userForm.weight_fundtypecat = response.user.profile.weight_fundtypecat;
                        this.userForm.weight_lptype = response.user.profile.weight_lptype;
                        this.userForm.weight_esg = response.user.profile.weight_esg;
                        this.userForm.weight_ftf = response.user.profile.weight_ftf;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/users/general-partners');
                    })
            },
            submit(){
                this.userForm.patch('/api/user/'+this.id)
                    .then(response => {
                        this.fetchUserData();
                        toastr.success(response.message);
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
          submit2(){
            this.showInvestorPreview();

            /*this.userForm.patch('/api/user/'+this.id)
                .then(response => {
                  this.fetchUserData();

                  toastr.success(response.message);
                })
                .catch(error => {
                  helper.showErrorMsg(error);
                }); */
          },
            userHasRole(user,role){
                return helper.userHasRole(user,role);
            }
        }
    }
</script>
<style>
.pta-gp-weightings label{
  display:block;
}
.pta-gp-weightings select option,
.pta-gp-weightings select{
  font-weight:400;
  font-size:14px;
}
</style>
